import { useCallback, useEffect, useState } from "react";
import { api } from "../../api.js";
import {
  Badge, EmptyState, LoadingRows, Notice, SelectField, Table, TableCell,
  TableHead, TableHeader, TableRow,
} from "../../components/ui.jsx";
import PaginationControls from "./PaginationControls.jsx";
import { formatDate } from "./utils.js";

const PAGE_SIZE = 25;

export default function RunsTab() {
  const [filters, setFilters] = useState({ status: "", offset: 0 });
  const [state, setState] = useState({ loading: true, runs: [], pagination: null, error: "" });

  const load = useCallback(async () => {
    setState((current) => ({ ...current, loading: true, error: "" }));
    try {
      const data = await api.platformCatalogRuns({
        limit: PAGE_SIZE,
        offset: filters.offset,
        ...(filters.status ? { status: filters.status } : {}),
      });
      setState({ loading: false, runs: data.runs, pagination: data.pagination, error: "" });
    } catch (error) {
      setState((current) => ({ ...current, loading: false, error: error.message }));
    }
  }, [filters]);

  useEffect(() => { load(); }, [load]);

  return (
    <div className="grid gap-5">
      <div className="max-w-[260px]">
        <SelectField label="Run status" value={filters.status} onChange={(event) => setFilters({ status: event.target.value, offset: 0 })}>
          <option value="">All statuses</option><option value="catalog_hit">Catalog hit</option><option value="succeeded">Succeeded</option><option value="partial">Partial</option><option value="no_result">No result</option><option value="failed">Failed</option><option value="running">Running</option>
        </SelectField>
      </div>
      {state.error && <Notice>{state.error}</Notice>}
      {state.loading ? <LoadingRows count={6} /> : state.runs.length ? (
        <>
          <Table>
            <TableHead><TableHeader>Company</TableHeader><TableHeader>Workspace</TableHeader><TableHeader>Fields</TableHeader><TableHeader>Provider</TableHeader><TableHeader>Credits</TableHeader><TableHeader>Status</TableHeader><TableHeader>Started</TableHeader></TableHead>
            <tbody>{state.runs.map((run) => (
              <TableRow key={run.id}>
                <TableCell><strong className="block text-[13px]">{run.company.name}</strong><small className="text-[11px] text-muted-foreground">{run.company.domain}</small></TableCell>
                <TableCell>{run.workspace.name}</TableCell>
                <TableCell><span title={run.requested_fields.join(", ")}>{run.requested_fields.length} requested · {run.cache_hit_fields.length} cached</span></TableCell>
                <TableCell>{run.provider || "—"}</TableCell>
                <TableCell>{run.credits_charged ?? "—"}</TableCell>
                <TableCell><Badge status={run.status}>{run.status.replaceAll("_", " ")}</Badge></TableCell>
                <TableCell className="whitespace-nowrap text-muted-foreground">{formatDate(run.created_at)}</TableCell>
              </TableRow>
            ))}</tbody>
          </Table>
          <PaginationControls pagination={state.pagination} onChange={(offset) => setFilters((current) => ({ ...current, offset }))} />
        </>
      ) : <EmptyState title="No retrieval runs" description="Catalog resolution requests from customer workspaces will appear here." />}
    </div>
  );
}
